import {Component, OnInit} from '@angular/core';
import {UpgradeModule} from "@angular/upgrade/static";
import {IconRegistry} from "./icons/icon-registry";
import {OnDestroyService} from 'src/app/core/services/on-destroy.service';

@Component({
	standalone: false,
    selector: 'app-angular',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [OnDestroyService]
})
export class AppComponent implements OnInit {
    constructor(
        private upgrade: UpgradeModule,
    ) {
        new IconRegistry();
    }

    ngOnInit(): void {
        this.upgrade.bootstrap(document.body, ['TilbyApp'], {strictDi: true});
    }

}
